/** Bazzef Messenger is the same client, built with REACT_APP_VARIANT=messenger. */
export const IS_MESSENGER = process.env.REACT_APP_VARIANT === 'messenger';

export const APP_NAME = IS_MESSENGER ? 'Bazzef Messenger' : 'Bazzef';

/** Native package / bundle id used for push routing. */
export const NATIVE_APP_ID = IS_MESSENGER ? 'com.bazzef.messenger' : 'com.bazzef.app';

/** Where a successful sign-in lands. */
export const APP_HOME = IS_MESSENGER ? '/messages' : '/home';
